import { FC, useState, useEffect } from 'react';
import styles from '@app/product/AddToCart/index.module.less';
import QtyBtns from '@app/product/AddToCart/QtyBtns';
import { IAddCartInstance } from '@base/product/useAddCart';
import { ProdSoldOut } from 'mod/product/ProdSoldOut';

type IQuickViewOptionsProps = {
    addCart: IAddCartInstance;
    qtyShown?: boolean;
    btnsShown?: boolean;
};

export const QuickViewOptions: FC<IQuickViewOptionsProps> = props => {
    const {
        addCart,
        qtyShown,
        btnsShown,
    } = props;

    const { shownVariant, outOfStock } = addCart;

    if (btnsShown && outOfStock) {
        return (
            <ProdSoldOut
                shownVariant={shownVariant}
                btnProps={{
                    type: 'b'
                }}
                className={styles['sold-out-quick']}
                popupProps={{
                    className: styles['sold-out-popup'],
                    btnProps: {
                        type: 'b'
                    }
                }}
            />
        )
    }

    return (qtyShown || btnsShown) ? (
        <div className={styles['form-bar']}>
            <QtyBtns
                addCart={addCart}
                qtyShown={qtyShown}
                btnsShown={btnsShown}
            />
        </div>
    ) : null
};
